import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagsService } from '../shared-service/feature-flags.service';

@Directive({
  selector: '[lfFeatureAnyOn]'
})
export class FeatureAnyFlagsDirective {

  @Input('lfFeatureAnyOn') features: string[];
  constructor(
    private vcr: ViewContainerRef,
    private tpl: TemplateRef<any>,
    private featureService: FeatureFlagsService
  ) { }

  async ngOnInit() {
    await this.featureService.initialize();
    if(!this.featureService.isAnyOn(this.features)) {
      this.vcr.createEmbeddedView(this.tpl);
    }
  }
}
